module.exports = __webpack_public_path__ + "img/delete.33b1e05b.svg";